import moment_timezone from "moment-timezone";
import moment from "moment";
import { arrayToSelectOptions } from "./arrayToSelectOptions";

export const USTimeZones = moment_timezone.tz.zonesForCountry("US", true);
export const CanadaTimeZones = moment_timezone.tz.zonesForCountry("US", true);
export const AllTimezones = [...USTimeZones, ...CanadaTimeZones];

export const TIMEZONE_SELECT_OPTIONS = arrayToSelectOptions([
  "US/Eastern",
  "US/Central",
  "US/Mountain",
  // "US/Arizona",
  "US/Pacific",
  "US/Alaska",
  // "US/Aleutian",
  // "US/Hawaii",
  // "Canada/Atlantic",
  // "Canada/Central",
  // "Canada/Eastern",
  // "Canada/Mountain",
  // "Canada/Newfoundland",
  // "Canada/Pacific",
  // "Canada/Saskatchewan",
  // "Canada/Yukon",
]);

export const getTimeZoneToSelectOptions = (USTimeZones) => {
  return [
    { val: "", text: "Select" },
    ...USTimeZones.map((val) => {
      let negative = val.offset > 0;
      let minutes = val.offset;
      let hrs = Math.round(minutes / 60)
        .toString()
        .padStart(2, "0");
      let mins = (minutes % 60).toString().padStart(2, "0");
      let text = `${val.name} (GMT${negative ? "-" : "+"}${hrs}:${mins})`;
      return { val: val.name, text: text };
    }),
  ];
};

export const getTimezoneOffsetFromTimezoneString = (timezone) => {
  return getTimezoneOffsetFromDate(moment.tz(timezone));
};

const getTimezoneOffsetFromDate = (date) => {
  const offset = date.utcOffset();
  let negative = offset < 0;
  let minutes = offset;
  if (negative) {
    minutes *= -1;
  }
  let hrs = Math.round(minutes / 60)
    .toString()
    .padStart(2, "0");
  let mins = (minutes % 60).toString().padStart(2, "0");
  return `GMT${negative ? "-" : "+"}${hrs}:${mins}`;
};

export const getTimezoneOffsetFromDateAndTimezone = (date, timezone) => {
  return getTimezoneOffsetFromDate(moment.tz(date, timezone));
};



// WEBPACK FOOTER //
// ./src/utils/timezone.js